/* NukkadTales — Gul's per-collection tales.
   Keyed by Shopify collection handle. The collection-hero section narrates
   the matching set; if a collection isn't listed it uses `_default`.
   Per-collection override: set the collection metafield custom.gul_stories
   (a list of text) in Shopify admin — that always wins over this map.

   Voice: short, warm, Hinglish-friendly, no self-introduction. */
window.NT_GUL_STORIES = {

  "for-family": [
    "Ek ghar mein sabse purana rishta — family. Carve it once, it sits on the shelf forever.",
    "One family kept their surname on the wall. Guests read it first, smile second.",
    "Maa-Papa, bhai-behen — alag log, ek hi ghar. That's the whole tale right there.",
    "Some words you grew up hearing. Wood just makes them stay a little longer."
  ],
  "for-father": [
    "Papa shows love by doing, never saying. A few carved words say it for him.",
    "Ek beta ne Papa ko diya — bas 'Papa' likha tha. Woh chup ho gaye. Samajh gaye.",
    "Retired, cricket on TV, chai in hand — and now his name on the shelf behind him.",
    "He never asked for anything. So we put the thank-you in wood."
  ],
  "for-mother": [
    "One maa wakes before everyone. That quiet hour is the only thing that's just hers.",
    "Maa ke liye kuch likha — woh boli 'tu samjha'. Bas wahi toh chahiye tha.",
    "Chai aur Maa — same feeling. Warm, always there, makes everything better.",
    "Her whole life she gave words to everyone. Time someone carved one for her."
  ],
  "for-couple": [
    "Do dil, ek shelf. The first thing they see walking into the new flat.",
    "One couple put their wedding date in wood. Now every morning starts with it.",
    "Better together — two words that hold up a whole home.",
    "You, me, this little ghar. Some tales don't need more than that."
  ],
  "for-girlfriend-wife": [
    "For the one who turned a house into a home — say it in wood.",
    "Ek pati ne wife ka naam carve karwaya. Surprise dinner ke beech rakh diya. She cried.",
    "Her favourite line, her handwriting's vibe, on her side of the shelf.",
    "Jaan, pyaar, ghar — pick the word that's most her."
  ],
  "for-boyfriend-husband": [
    "For the man who keeps it together quietly — a line that finally says it loud.",
    "One wife gifted 'My person, always'. He keeps it on his work desk now.",
    "Cricket, bikes, late-night chai — and now a little tale that's all his.",
    "Not flowers, not a card. Something that stays on his shelf for years."
  ],
  "siblings": [
    "Bhai-behen ki ladaai, bhai-behen ka pyaar — same day, same person.",
    "One sister sent her brother a tale across cities. Rakhi ka asli gift wahi tha.",
    "Your first friend, your first rival, your forever team.",
    "The one who knows all your secrets — carve them a tale, not a card."
  ],
  "for-friends": [
    "The family you chose. Some dosti deserves more than a WhatsApp forward.",
    "Ek group ne ek dusre ko same tale gift kiya. Sabke ghar mein wahi shelf pe hai.",
    "Distance changes nothing — but a little wood on the shelf helps.",
    "Yaar, partner-in-crime, 2am-call person. That's the tale."
  ],
  "for-boss": [
    "For the boss who actually mentored, not just managed.",
    "One team gifted their manager on the last day. He kept it. Still there.",
    "Respect ka gift — subtle, classy, sits on the office desk.",
    "Not a generic plaque. A line that means you noticed."
  ],
  "office-decor": [
    "Hits different on a hard Monday — the right line on the desk.",
    "One founder kept 'Apna time aayega' facing the team. Energy shifted.",
    "Desk pe ek tale — small reminder that the grind has a point.",
    "Calm in the chaos, or fire for the hustle. Pick your desk's mood."
  ],
  "study-decor": [
    "For the late-night reader and the early-morning grinder.",
    "Ek student ne apni desk pe 'Keep going' rakha. Boards nikal gaye.",
    "Books, chai, deadlines — and one line that keeps the head up.",
    "Quiet motivation for the corner where the real work happens."
  ],
  "kitchen-decor": [
    "Her kitchen made this house a home. Say so, on the wall above the stove.",
    "Masala, chai, hungama — the kitchen is where the family actually lives.",
    "One line where the magic happens — warm, a little funny, very ghar.",
    "Ghar ki khushboo kitchen se aati hai. Carve a tale that fits."
  ],
  "home-decor": [
    "The tale every guest stops to read on their way in.",
    "Ek ghar mein 'Good vibes only' entrance pe lagaya. Mood set, har baar.",
    "Bedroom whisper or living-room statement — home decides the line.",
    "Walls full of photos already? Give them words to live with."
  ],
  "motivational": [
    "Apna time aayega — four words that carried a thousand hard days.",
    "One day, or day one. The shelf reminds you which one you picked.",
    "Born to shine — kept where you'll see it before the doubt arrives.",
    "Rise, again, always. Small wood, big push."
  ],
  "religious-spiritual-quotes": [
    "Sabr aur shukr — do shabd jinpe poora ghar tikta hai.",
    "One family kept a mantra by the pooja corner. Mornings feel steadier.",
    "Faith doesn't need to shout. A quiet line on the shelf is enough.",
    "Peace, gratitude, grace — carved soft, felt deep."
  ],
  "mantra": [
    "Ek saans, ek shabd — sukoon wahin se shuru hota hai.",
    "Breathe. You're home now. Some shelves just hold a reminder.",
    "Slow mornings, full heart — the mantra that runs a calm house.",
    "Stillness is a gift. Carve the one that quiets your noise."
  ],
  "hindi": [
    "Kuch baatein Hindi mein hi dil tak jaati hain.",
    "Ek line apni bhasha mein — ghar wapas aane jaisa lagta hai.",
    "Dil garden garden — when everything's just right.",
    "Maatra, lehja, apnapan — Hindi tales hit a softer spot."
  ],
  "unisex": [
    "No labels, no 'for him / for her' — just a good line for a good human.",
    "Funny, warm, a little cheeky — tales that fit absolutely anyone.",
    "One safe gift that never misses, whoever it's for.",
    "Good vibes, zero overthinking. Pick, gift, done."
  ],
  "delulu-decor": [
    "Delulu is the solulu — say it loud, say it on the shelf.",
    "For the dreamer who's a little extra and fully owns it.",
    "Quirky tales for people who don't do boring walls.",
    "Half joke, half manifestation — completely you."
  ],
  "artist": [
    "For the hands that can't sit still — a tale for the maker's corner.",
    "Ek artist ne apne studio mein apni hi line lagaayi. Fuel.",
    "Create like nobody's watching — even when they are.",
    "Messy desk, full heart — the creative's kind of order."
  ],
  "personalisation": [
    "Your words, your name, your date — carved exactly that, nothing generic.",
    "Ek line jo sirf aapke log samajhte hain. Wahi toh personal hai.",
    "Type it, we carve it — bilkul aapki tarah, one of one.",
    "A name on wood turns a gift into a memory."
  ],
  "all-personalisation": [
    "Anything you can say, we can carve — name, date, inside joke, all of it.",
    "One of one. Likho jo dil mein hai, baaki hum sambhaal lenge.",
    "The gift that exists nowhere else — because it's literally yours.",
    "Custom words, real wood, forever shelf."
  ],
  "professional-personalisations": [
    "Logos, founding dates, team names — your brand, carved with care.",
    "One office gifted clients their own logo in wood. Repeat orders followed.",
    "Corporate gift that isn't forgettable — personal, premium, lasting.",
    "Your mark on the desk, not just a sticker on a mug."
  ],
  "thoughtful-and-unique-gifts": [
    "The gift they didn't expect and won't forget.",
    "Ek soch ke diya gift — wahi sabse zyada yaad rehta hai.",
    "Not another candle. A line made for exactly this person.",
    "Unique, warm, ready to wrap — gifting, sorted."
  ],
  "birthday-sale-1": [
    "Happy birthday — but make it a gift that stays on the shelf, not the bin.",
    "Ek naam, ek date, ek line — birthday wala perfect tofa.",
    "Another year, one good reminder carved in wood.",
    "Cake finishes; a tale doesn't."
  ],
  "bestseller": [
    "These are the tales people keep coming back for — loved across every home.",
    "Sabse zyada gift ki gayi lines — there's a reason they're on top.",
    "Tried, tested, teared-up-over. The crowd favourites.",
    "Start here — these rarely miss."
  ],
  "new-collection": [
    "Fresh off the artisan's bench — the newest tales on the nukkad.",
    "Abhi-abhi carve hui lines — be the first to put one up.",
    "New words, same warm wood.",
    "Just arrived, already hard to choose."
  ],
  "sahab-sahiba": [
    "Sahab aur Sahiba — thoda nakhra, poora pyaar.",
    "For the couple who run the house like royalty (and know it).",
    "Ek shaahi si line, do logon ke naam.",
    "Classic, warm, a little regal — just like them."
  ]

};
window.NT_GUL_STORIES._default = window.NT_GUL_STORIES._default || [
  "Every shelf here tells a story. Tap me and I'll share one from this collection.",
  "Some words don't need a greeting card. Carved in wood, they just stay — and mean everything.",
  "Pick the tale that sounds like someone you love. That's usually the right one.",
  "I know every line carved on this nukkad. Take your time — the right one finds you."
];
